class mapStorage {
    constructor(type) {
        this.type = type
    }
    storage() {
        return this.type && this.type === 'session' ? sessionStorage : localStorage
    }
    has(key) {
        return !!(this.storage().getItem(key))
    }
    setItem(key, value) {
        return this.storage().setItem(key, JSON.stringify(value))
    }
    getItem(key) {
        return JSON.parse(this.storage().getItem(key))
    }
    removeItem(key) {
        return this.storage().removeItem(key)
    }
    clear() {
        return this.storage().clear()
    }
}

exports.storage = new mapStorage()
exports.session = new mapStorage('session')
